/* Product page: share, and the size guide link.

   Both are progressive enhancement over markup that already works. The size
   guide is a <details>, open it with a click or leave it and it still opens by
   itself. The share control ships hidden and this file is what reveals it,
   because a share button that silently does nothing is worse than no button. */
(function () {
  'use strict';

  /* ----- Share ----- */
  (function () {
    var wrap = document.querySelector('[data-share]');
    if (!wrap) return;

    var btn = wrap.querySelector('[data-share-btn]');
    var said = wrap.querySelector('[data-share-said]');
    if (!btn) return;

    var url = btn.getAttribute('data-share-url') || window.location.href;
    var title = btn.getAttribute('data-share-title') || document.title;

    var canShare = typeof navigator.share === 'function';
    var canCopy = !!(navigator.clipboard && navigator.clipboard.writeText);

    // Nothing this browser can do, so leave the control hidden rather than
    // offering an action that will fail.
    if (!canShare && !canCopy) return;
    wrap.hidden = false;

    function say(msg) {
      if (!said) return;
      said.textContent = msg;
      window.setTimeout(function () { said.textContent = ''; }, 3000);
    }

    btn.addEventListener('click', function () {
      if (canShare) {
        // The share sheet is the right answer on a phone: it opens Messages,
        // WhatsApp and Instagram rather than a row of buttons nobody presses.
        navigator.share({ title: title, url: url }).catch(function (err) {
          // A cancelled share is a normal outcome, not a failure to report.
          if (err && err.name === 'AbortError') return;
          if (canCopy) {
            navigator.clipboard.writeText(url)
              .then(function () { say('Link copied'); })
              .catch(function () { say('Could not share'); });
          }
        });
        return;
      }

      navigator.clipboard.writeText(url)
        .then(function () { say('Link copied'); })
        .catch(function () { say('Could not copy'); });
    });
  })();

  /* ----- Size guide link ----- */
  (function () {
    var opener = document.querySelector('[data-sizeguide-open]');
    var guide = document.getElementById('sizeGuide');
    if (!opener || !guide) return;

    opener.addEventListener('click', function () {
      guide.open = true;
      // Scroll after the details has expanded, or the target lands short.
      window.requestAnimationFrame(function () {
        guide.scrollIntoView({ block: 'center', behavior: 'smooth' });
        var summary = guide.querySelector('summary');
        // Move focus so a keyboard user is where the eye already went.
        if (summary) summary.focus({ preventScroll: true });
      });
    });
  })();
})();
